import React from 'react'
import { Column } from 'react-table'

import { PlaceWithAnalytics } from '../../types/utils'
import Table from '../Table'
import TableSkeleton from '../TableSkeleton'

type AnalyticsTableProps = {
  data: PlaceWithAnalytics[] | undefined
  isLoading: boolean
}

const AnalyticsTable: React.FC<AnalyticsTableProps> = (props) => {
  const columns = React.useMemo<Column<PlaceWithAnalytics>[]>(
    () => [
      {
        id: 'customer_name',
        Header: 'Customer',
        accessor: ({ customer }) => {
          if (!customer) return null
          return customer.name
        },
      },
      {
        id: 'location',
        Header: 'Location',
        accessor: 'name',
      },
      {
        id: 'views',
        Header: 'Views',
        accessor: ({ analytics }) => analytics.views,
      },
      {
        id: 'actions',
        Header: 'Actions',
        accessor: ({ analytics }) => analytics.actions,
      },
      {
        id: 'nbExperiences',
        Header: 'Total Experiences',
        accessor: 'nbExperiences',
      },
      {
        id: 'positive',
        Header: '# of Postive',
        accessor: ({ analytics }) => analytics.nbPositiveExperiences,
      },
      {
        id: 'neutral',
        Header: '# of Neutral',
        accessor: ({ analytics }) => analytics.nbNeutralExperiences,
      },
      {
        id: 'negative',
        Header: '# of Negative',
        accessor: ({ analytics }) => analytics.nbNegativeExperiences,
      },
      {
        id: 'distinctExperience',
        Header: 'Distinct Experience',
        accessor: ({ analytics }) => `${analytics.distinctExperiencesPercentage}`,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (!props.data) {
    return null
  }

  if (props.isLoading) {
    return (
      <TableSkeleton
        headers={[
          'Customer',
          'Location',
          'Views',
          'Actions',
          'Total Experiences',
          '# of Postive',
          '# of Neutral',
          '# of Negative',
        ]}
      />
    )
  }

  return (
    <div className="mt-5">
      <Table columns={columns} data={props.data} />
    </div>
  )
}

export default AnalyticsTable
